import { Box, BoxProps, Image, Text, VStack } from '@chakra-ui/react';
import logo from '../images/header-logo.webp';
import RSVP from './RSVP';

const Home: React.FC<BoxProps> = ({ ...props }) => {
  return (
    <VStack justifyContent="space-evenly" {...props} position="relative">
      <Box textAlign="center">
        {/* <Text
          textTransform="uppercase"
          letterSpacing="3px"
          color="#ffffff"
          fontSize={['xs', 'md']}
        >
          Save the date for the wedding of
        </Text> */}
        <Image
          src={logo}
          alt="Keshawa & Carrie are getting married."
          h="260px"
          w="auto"
          m="auto"
        />
        {/* <Heading
          // lineHeight={['60px', '100']}
          // fontSize={['60px', '120px']}
          fontSize={['64px', '100px']}
          lineHeight={['60px', '100px']}
          color="#eae9eb"
          fontWeight={200}
          my={[6, 8]}
          fontFamily="TheSeasons"
          letterSpacing={6}
          px={4}
          py={10}
          textAlign="right"
        >
          KESHAWA <br />
          <Text
            as="span"
            fontFamily="Lustria"
            fontSize={['32px', '64px']}
            verticalAlign="text-top"
            color="#9b8ea0"
          >
            &
          </Text>
          CARRIE
        </Heading> */}
        <Text
          textTransform="uppercase"
          letterSpacing="3px"
          color="#ffffff"
          fontSize={['lg', '2xl']}
          mt={12}
        >
          21.10.2025
        </Text>
        <RSVP />

        {/* <Link
          href="https://maps.app.goo.gl/V651x8ZtwsxhM65d7"
          target="_blank"
          mt="2"
          textTransform="uppercase"
          letterSpacing="3px"
          color="#ffffff"
          fontSize={['sm', 'md']}
          textDecor="none"
        >
          Aquila Crystal Palace Tagaytay, Philippines
          <BsArrowUpRight
            display="inline-block"
            style={{
              display: 'inline',
              verticalAlign: 'middle',
              fontSize: '2xs',
            }}
          />
        </Link> */}
      </Box>
    </VStack>
  );
};

export default Home;
